import React from 'react';

import StarFilled from './Stars/filled';
import StarHalfFilled from './Stars/half-filled';
import StarUnFilled from './Stars/unfilled';

export interface StarInterface {
  width: number;
  isOnDark: boolean;
  color: string;
  viewBox: string;
}

type StarValidFilledValues = 0 | 0.5 | 1;

interface StarProps {
  filled: StarValidFilledValues;
  isOnDark: boolean;
  starWidth: number;
}

/**
 * @deprecated V2 component
 */
const Star: React.FC<StarProps> = ({ filled, isOnDark, starWidth }) => {
  const color = isOnDark ? '#C3DBFF' : '#4C5C74';

  const viewbox = `0 0 ${starWidth} ${starWidth}`;
  if (filled === 1) {
    return (
      <StarFilled
        viewBox={viewbox}
        color={color}
        isOnDark={isOnDark}
        width={starWidth}
      />
    );
  } else if (filled === 0.5) {
    return (
      <StarHalfFilled
        viewBox={viewbox}
        color={color}
        isOnDark={isOnDark}
        width={starWidth}
      />
    );
  } else {
    return (
      <StarUnFilled
        viewBox={viewbox}
        color={color}
        isOnDark={isOnDark}
        width={starWidth}
      />
    );
  }
};

export default Star;
